import AllAssignmentItem from '../Domain/AllAssignmentItem';
import ExcludedAssignmentItem from '../Domain/ExcludedAssignmentItem';
import FinalizedAssignmentClientItem from '../Domain/FinalizedAssignmentClientItem';
import FinalizedAssignmentItem from '../Domain/FinalizedAssignmentItem';
import UninvoiceableAssignmentItem from '../Domain/UninvoiceableAssignmentItem';
import serviceHelper from '../Helpers/serviceHelper';
import AuthService from './authService';
import SearchParams from '../Elements/SearchParams';
import AssignmentSearchParams from '../Contents/Operations/Projects/Assignments/AssignmentSearchParams';

export default class ProjectAssignmentService {
  static GetAssignmentList(orderById, orderDir, pageNumber, numberOfElements, searchItem, clearCache = false) {
    const authService = AuthService.getInstance();
    let url = '/api/ProjectAssignment/GetAssignmentsBySearchingAsync?';

    const searchParams = new SearchParams(
      searchItem,
      AssignmentSearchParams,
      orderById,
      orderDir,
      pageNumber,
      numberOfElements
    );

    url += `searchParams=${searchParams.serializeForBackendCall()}`;
    url += `&clearCache=${clearCache}`;

    return authService.CallBackendFunction(url);
  }

  static ConvertFinalizedDBItems(itemlist) {
    if (itemlist !== null) {
      return itemlist.map((item) => new FinalizedAssignmentItem(item));
    }
    return [];
  }

  static ConvertFinalizedClientDbItems(itemlist) {
    if (itemlist !== null) {
      return itemlist.map((item) => new FinalizedAssignmentClientItem(item));
    }
    return [];
  }

  static ConvertUninvoiceableDBItems(itemlist) {
    if (itemlist !== null) {
      return itemlist.map((item) => new UninvoiceableAssignmentItem(item));
    }
    return [];
  }

  static ConvertExcludedDBItems(itemlist) {
    return itemlist !== null ? itemlist.map((item) => new ExcludedAssignmentItem(item)) : [];
  }

  static ConvertAllDBItems(itemlist) {
    return itemlist !== null ? itemlist.map((item) => new AllAssignmentItem(item)) : [];
  }

  static EditMultipleAssignment(item, itemList, allItemInTheSearchAreSelected, searchParameters) {
    const url = '/api/ProjectAssignment/EditMultipleRecords';
    item.AllItemInTheSearchAreSelected = allItemInTheSearchAreSelected;
    item = serviceHelper.ConvertAllPropertyToString(item);
    item.Ids = itemList.map((s) => s.AsSassieAsgnId);
    item.SearchParameters = { ...searchParameters };

    return AuthService.getInstance().CallBackendFunctionPut(url, item);
  }

  static GenerateAssignmentPayment(item, searchItem, allItemsInTheSearchAreSelected) {
    const searchParams = new SearchParams(searchItem, AssignmentSearchParams, '', '', 0, 0);
    // Encoded as a whole: the list request encodes its text filters (TabOfDataTable), so an unencoded '&', '#' or
    // '+' in one (e.g. a client named "B&Q") would cut or change the search here and "select all" would not
    // resolve to the rows listed.
    return AuthService.getInstance().CallBackendFunctionPost(
      '/api/ClientInvoice/GenerateAssignmentPayment?searchParams=' +
        encodeURIComponent(searchParams.serializeForBackendCall()) +
        '&allItemsInTheSearchAreSelected=' +
        JSON.stringify(allItemsInTheSearchAreSelected),
      JSON.stringify(item)
    );
  }

  static GetProjectAssignmentAdditionalInformation(id) {
    const authService = AuthService.getInstance();
    const url = `/api/ProjectAssignment/GetProjectAssignmentAdditionalInformation/${id}?clearCache=true`;
    return authService.CallBackendFunction(url);
  }
}
